export const returns = {
  orderCancellation: {
    breadcrumb: {
      service: 'Service Benefits',
      cancellation: 'Returns & Order Cancellation',
      success: 'Confirmation',
    },
    page: {
      title: 'Return or Cancellation of Your Order',
      introText1:
        'You can initiate a return or cancellation for your order via the form below. This option is available for both registered customers and guest orders.',
    },
    form: {
      orderNumber: 'Order number',
      orderNumberError: 'Please enter your order number.',
      customerNumber: 'Customer number',
      submit: 'VIEW ORDER',
    },
    cancelOrder: {
      title: 'Cancel or return items',
      introText2:
        'Select the items you want to cancel or return and confirm your request below. Some items are excluded from return, such as configured or custom-made products.',
      orderHeading: 'Order {{orderNumber}}',
      orderDate: 'Order date:',
      selectAll: 'Select all',
      columnArticle: 'Article',
      columnQuantity: 'Quantity',
      columnUnitPrice: 'Unit price',
      columnTotalPrice: 'Total price',
      confirmationLabel: 'I confirm that I want to return the selected items from this order',
      contactNameLabel: 'Name of contact person',
      contactEmailLabel: 'Email address of contact person',
      contactEmailError: 'Please enter a valid email address.',
      submitButton: 'Cancel or Return',
      submitHint:
        'Once you click "Cancel & Return Items", we will send you a confirmation email that your request has been received.',
      notFoundError:
        'The order number or customer number entered could not be found. Please check your details.',
      notCancellableTitle: 'This order is excluded from cancellation',
      notCancellableIntro:
        'Certain items, such as configured or custom-made products, cannot be cancelled after the order has been placed. If you have any questions, please contact customer service.',
      notCancellableContactLink: 'Contact customer service',
      backToHome: 'Back to home',
    },
    productCard: {
      articleNumber: 'Article number: {{code}}',
      quantity: 'Quantity',
      net: 'Net',
      returnQuantityLabel: 'Quantity',
      reasonLabel: 'What is the reason for the return? (optional)',
      descriptionLabel: 'Description',
      reason: {
        damageBefore: 'Damage before use',
        damageAfter: 'Damage after use',
        wrongItem: 'Wrong item delivered',
        wrongQuantity: 'Wrong quantity delivered',
        return: 'Return within cancellation period',
      },
      notCancellableText: 'This item is excluded from cancellation as it was individually manufactured.',
      notCancellableContactPrefix: 'If you have any questions about this restriction, please contact our ',
      notCancellableContactLink: 'customer service',
    },
    success: {
      title: 'Thank you. We have received your request.',
      backToHome: 'Back to home',
      returnSectionHeading: 'Return items',
      returnSectionText:
        'If you have already received your items, you can download a return label below. We will cover the return shipping costs.',
      dhlButton: 'Print DHL return label',
      postButton: 'Print Post return label',
      dropOffHeading: 'You can find a parcel drop-off point near you',
      dropOffDhlPrefix: 'for DHL:',
      dropOffPostPrefix: 'for Post AT:',
    },
  },
  breadcrumb: {
    service: 'Service-Benefits',
    returns: 'Returns',
  },
  returns: {
    page: {
      title: 'Returns at HABA',
      introHeading: 'How do I return an item?',
      introText:
        'When you shop at HABA you order on approval, meaning you can return delivered goods free of charge and without giving reasons within 4 weeks of receipt.',
      stepsHeading: 'Returning items to HABA is this easy',
      steps: {
        originalPackaging:
          'Ideally in the original packaging (otherwise max. 60 x 60 x 120 cm and up to 31.5 kg)',
        returnSlip:
          'Please place the return form with the completed reasons for return in the parcel. Let us know how we can improve!',
        label:
          'Affix the HABA return label clearly to the parcel. Your return shipment will then be free of charge!',
        receipt: 'Keep the shipping receipt safe in case the parcel gets lost.',
      },
      noLabelHeading: 'No return label at hand?',
    },
    form: {
      description:
        'Print it right here. Enter your order number in the input field below and click submit.',
      orderNumberLabel: 'Order number',
      orderNumberPlaceholder: 'Order number',
      submit: 'Submit',
      invalidOrder: 'The order number entered is invalid or could not be found.',
      instructionsHeading: "Create your own return label – it's that easy:",
      instructions: {
        dhl: 'Returns are handled by DHL.',
        onlineForm: 'The online return form will open.',
        enterData: 'Enter your data.',
        receiveLabel:
          'You receive your return label by email and can print it out directly. Or simply save the QR code on your smartphone and show it at the parcel shop.',
      },
      dhlImageAlt: 'DHL return shipment',
      returnAT: 'Postal return slip',
    },
  },
};
